import { useAtom } from 'jotai'
import { WidgetInputToggleField } from '../../rapid-ui'
import { landingPageMetaLogoBackgroundFillColorAtom, landingPageMetaShowLogoAtom } from '../state'
import { trackLandingPageEdited } from '../tracking'
import { EditorWidgetColorField } from './shared/editor-widget-color-field'

export function LandingPageContentLayerControls() {
	const [logoBackgroundFillColor, setLogoBackgroundFillColor] = useAtom(landingPageMetaLogoBackgroundFillColorAtom)
	const [showLogo, setShowLogo] = useAtom(landingPageMetaShowLogoAtom)

	return (
		<div className="text-left ml-10 mb-4 grid grid-cols-[auto_1fr] items-center gap-2">
			<div className="text-xs text-grey-600">
				Show logo
			</div>
			<WidgetInputToggleField
				value={showLogo ?? true}
				onChange={(value) => {
					setShowLogo(value)
					trackLandingPageEdited('logo_visibility')
				}}
				ariaLabel="Show logo"
			/>
			<div className="text-xs text-grey-600">
				Logo background
			</div>
			<EditorWidgetColorField
				value={logoBackgroundFillColor ?? '#ffffff'}
				onChange={(value) => {
					setLogoBackgroundFillColor(value)
					trackLandingPageEdited('logo_background_color')
				}}
				label="Logo background"
				includeTransparent
			/>
		</div>
	)
}
